import { render, staticRenderFns } from "./global-video-screen-recording.vue?vue&type=template&id=6cc73fc1"
import script from "./global-video-screen-recording.vue?vue&type=script&lang=js"
export * from "./global-video-screen-recording.vue?vue&type=script&lang=js"
import style0 from "./global-video-screen-recording.vue?vue&type=style&index=0&id=6cc73fc1&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc73fc1')) {
      api.createRecord('6cc73fc1', component.options)
    } else {
      api.reload('6cc73fc1', component.options)
    }
    module.hot.accept("./global-video-screen-recording.vue?vue&type=template&id=6cc73fc1", function () {
      api.rerender('6cc73fc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/video-screen-recording/global-video-screen-recording.vue"
export default component.exports